import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Login.css';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    // Hata mesajını kaldırma - kullanıcı görebilsin diye
    // setError(''); // Bu satırı kaldırdık
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('🔐 Giriş denemesi:', formData.email);
      const response = await authAPI.login(formData.email, formData.password);
      console.log('✅ Login response:', response.data);

      if (response.data.success && response.data.token && response.data.user) {
        console.log('💾 Token ve user kaydediliyor...');
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));

        console.log('👤 User role:', response.data.user.role?.role_name);

        // Başarılı giriş sonrası yönlendirme
        if (response.data.user.role?.role_name === 'admin' || response.data.user.role?.role_name === 'lawyer') {
          console.log('🎯 Admin paneline yönlendiriliyor...');
          navigate('/admin');
        } else {
          console.log('🏠 Ana sayfaya yönlendiriliyor...');
          navigate('/');
        }

        // Sayfa yenileme - sadece başarılı girişte
        setTimeout(() => {
          console.log('🔄 Sayfa yenileniyor...');
          window.location.reload();
        }, 100);
      } else {
        console.error('❌ Giriş başarısız:', response.data);
        setError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
        setLoading(false);
      }
    } catch (err: any) {
      console.error('❌ Login hatası:', err);
      console.error('Response:', err.response);
      // Hata durumunda sadece mesajı göster, sayfa yenilenmesin
      setError(err.response?.data?.message || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
      setLoading(false);
    }
  };

  return (
    <div className="login-split-container">
      {/* Sol Taraf - Görsel Alan */}
      <div className="login-visual-side">
        <div className="visual-overlay"></div>
        <div className="visual-content">
          <div className="visual-logo">
            <i className="bi bi-bank2"></i>
          </div>
          <h1 className="visual-title">Karadaş Hukuk Bürosu</h1>
          <p className="visual-subtitle">Adaletin ve Güvenin Adresi</p>
          <div className="visual-features">
            <div className="feature-item">
              <i className="bi bi-shield-check"></i>
              <span>Güvenli Erişim</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-clock-history"></i>
              <span>7/24 Destek</span>
            </div>
            <div className="feature-item">
              <i className="bi bi-file-earmark-text"></i>
              <span>Dijital Arşiv</span>
            </div>
          </div>
        </div>
      </div>

      {/* Sağ Taraf - Form Alanı */}
      <div className="login-form-side">
        <div className="form-container">
          {/* Başlık */}
          <div className="form-header">
            <h1 className="form-main-title">Karadaş Hukuk Bürosu</h1>
            <p className="form-subtitle">Yönetim Paneline Hoş Geldiniz</p>
          </div>

          {/* Hata Mesajı */}
          {error && (
            <div className="error-message">
              <i className="bi bi-exclamation-circle-fill"></i>
              <span>{error}</span>
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} className="login-form">
            {/* E-posta Alanı */}
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                <i className="bi bi-envelope"></i>
                E-posta Adresi
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="ornek@email.com"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>

            {/* Şifre Alanı */}
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                <i className="bi bi-lock"></i>
                Şifre
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  className="form-input password-input"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={6}
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                </button>
              </div>
            </div>

            {/* Beni Hatırla & Şifremi Unuttum */}
            <div className="form-options">
              <label className="remember-me">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                  className="custom-checkbox"
                />
                <span className="checkbox-label">Beni Hatırla</span>
              </label>
              <Link to="/forgot-password" className="forgot-link">
                Şifremi Unuttum
              </Link>
            </div>

            {/* Giriş Butonu */}
            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-icon"></span>
                  Giriş yapılıyor...
                </>
              ) : (
                <>
                  <i className="bi bi-arrow-right-circle"></i>
                  Giriş Yap
                </>
              )}
            </button>
          </form>

          {/* Alt Bilgi */}
          <div className="form-footer">
            <p className="footer-text">
              Hesabınız yok mu?{' '}
              <Link to="/register" className="register-link">
                Kayıt Ol
              </Link>
            </p>
          </div>

          {/* Güvenlik Bilgisi */}
          <div className="security-info">
            <i className="bi bi-shield-lock"></i>
            <span>Güvenli bağlantı ile korunmaktasınız</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
